const logoutFromSlash = () => {
  window.postMessage({ type: 'LOGOUT_FROM_SLASH' }, '*');
};

export default logoutFromSlash;
